<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
}
body,html {
  width: 100%;
}
#app {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue